// extracted by mini-css-extract-plugin
export var background = "dt_y";
export var close = "dt_j3";
export var content = "dt_cg";
export var frame = "dt_jZ";
export var menuBackground = "dt_j1";
export var menuContent = "dt_j2";
export var open = "dt_j0";